/* src/app/subcontractor/pages/subcontractor-depot-add/subcontractor-depot-add.component.scss */
/*# sourceMappingURL=subcontractor-depot-add.component.css.map */
